module.exports = __webpack_public_path__ + "b-corp-m-uk-n8W.png";